<template lang="">
  <FullScreenLayout>
    <template #page-content="props">
      <v-row class="fill-height justify-center">
        <v-col
          class="d-none d-sm-flex justify-center"
          style="justify-content: center; align-items: center"
          sm="6"
          lg="8"
        >
          <WelcomeSlide></WelcomeSlide>
        </v-col>
        <v-col
          xs="12"
          class="fill-height justify-center white pa-10"
          id="navbar-right"
          style="justify-content: center; align-items: center"
          sm="6"
          lg="4"
        >
          <v-card xs="12" sm="12" tile elevation="0">
            <FrmLoginOwner :showLogo="Boolean(isMobile)"></FrmLoginOwner>
          </v-card>
        </v-col>
      </v-row>
      <!--<vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="90"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="false"
        clickMode="push"
      >
      </vue-particles>-->
    </template>
  </FullScreenLayout>
</template>
<style lang="scss">
#navbar-right {
}
#particles-js {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
}
.mainPage[isMobile] #frm-login {
  position: fixed;
  top: 0px;
  left: 0px;
  border-radius: 0 !important;
  right: 0;
  bottom: 0;
}
</style>

<script>
import FrmLoginOwner from "../components/FrmLogin/FrmLoginOwner";
import WelcomeSlide from "../components/WelcomePage/WelcomeSlide.vue";
import FullScreenLayout from "../layout/FullScreenLayout.vue";
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  components: {
    FrmLoginOwner,
    FullScreenLayout,
    WelcomeSlide,
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.checkIfIsMobile();
    });
    this.checkIfIsMobile();
  },
  computed: {},
  methods: {
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
  },
};
</script>
